import React, { useState } from 'react';


import Navbar from './Navbar';
import Footer from './Footer';




import img01 from '../assets/glass-img/a-1.jpg';
import img02 from '../assets/glass-img/a-2.jpg';
import img03 from '../assets/glass-img/a-3.jpg';
import img04 from '../assets/glass-img/a-4.jpg';
import img05 from '../assets/glass-img/a-5.jpg';
import img06 from '../assets/glass-img/a-6.jpg';
import img07 from '../assets/glass-img/a-7.jpg';
import img08 from '../assets/glass-img/a-8.jpg';
import img09 from '../assets/glass-img/a-9.jpg';
import img10 from '../assets/glass-img/a-10.jpg';
import img11 from '../assets/glass-img/a-11.jpg';
import img12 from '../assets/glass-img/a-12.jpg';
import img13 from '../assets/glass-img/a-13.jpg';
import img14 from '../assets/glass-img/a-14.jpg';
import img15 from '../assets/glass-img/a-24.jpg';
import img16 from '../assets/glass-img/a-15.jpg';
import img17 from '../assets/glass-img/a-16.jpg';
import img18 from '../assets/glass-img/a-17.jpg';
import img19 from '../assets/glass-img/a-18.jpg';
import img20 from '../assets/glass-img/a-19.jpg';
import img21 from '../assets/glass-img/a-20.jpg';
import img22 from '../assets/glass-img/a-21.jpg';
import img23 from '../assets/glass-img/a-22.jpg';
import img24 from '../assets/glass-img/a-23.jpg';

import img25 from '../assets/glass-img/img-01.jpg';
import img26 from '../assets/glass-img/img-02.jpg';
import img27 from '../assets/glass-img/img-03.jpg';
import img28 from '../assets/glass-img/img-04.jpg';
import img29 from '../assets/glass-img/img-05.jpg';
import img30 from '../assets/glass-img/img-06.jpg';
import img31 from '../assets/glass-img/img-07.jpg';
import img32 from '../assets/glass-img/img-08.jpg';
import img33 from '../assets/glass-img/img-09.jpg';
import img34 from '../assets/glass-img/img-10.jpg';
import img35 from '../assets/glass-img/img-11.jpg';
import img36 from '../assets/glass-img/img-12.jpg';
import img37 from '../assets/glass-img/img-13.jpg';
import img38 from '../assets/glass-img/img-14.jpg';
import img39 from '../assets/glass-img/img-15.jpg';
import img40 from '../assets/glass-img/img-16.jpg';
import img41 from '../assets/glass-img/img-17.jpg';
import img42 from '../assets/glass-img/img-18.jpg';
import img43 from '../assets/glass-img/img-19.jpg';
import img44 from '../assets/glass-img/img-20.jpg';
import img45 from '../assets/glass-img/img-21.jpg';
import img46 from '../assets/glass-img/img-22.jpg';
import img47 from '../assets/glass-img/img-23.jpg';
import img48 from '../assets/glass-img/img-24.jpg';
import img49 from '../assets/glass-img/img-25.jpg';
import img50 from '../assets/glass-img/img-26.jpg';
import img51 from '../assets/glass-img/img-27.jpg';
import img52 from '../assets/glass-img/img-28.jpg';
import img53 from '../assets/glass-img/img-29.jpg';
import img54 from '../assets/glass-img/img-30.jpg';
import img55 from '../assets/glass-img/img-31.jpg';
import img56 from '../assets/glass-img/img-32.jpg';



const Gallery = () => {
    const [selectedImage, setSelectedImage] = useState(null); // State to hold the currently selected image

    const images = [
        img01,img02,img03,img04,img05,img06,img07,img08,img09,img10,img11,img12,img13,img14,img15,img16,img17,img18,img19,img20,img21,img22,img23,img24,img25,img26,img27,img28,img29,img30,img31,img32,img33,img34,img35,img36,img37,img38,img39,img40,img41,img42,img43,img44,img45,img46,img47,img48,img49,img50,img51,img52,img53,img54,img55,img56
        

        // Add the rest of the images here...
    ];

    const handleImageClick = (image) => {
        setSelectedImage(image); // Set the selected image
    };

    const handleClose = () => {
        setSelectedImage(null); // Clear the selected image
    };

    return (
        <div>

            {/* <Navbar /> */}
            <section id="work" className="py-12 bg-gray-100 mt-10">
                <div className="container mx-auto px-4">
                    <h1 className="text-4xl font-bold text-center mb-4">
                        <span className="text-purple-800">OUR GALLERY </span>
                    </h1>
                    <p className="text-center font-semibold text-gray-600 mb-8">
                        <span>We provide high standard work for your Company solutions</span>
                    </p>

                    <div className="grid grid-cols-2 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
                        {images.map((image, index) => (
                            <div
                                key={index}
                                className="overflow-hidden rounded-lg shadow-md hover:shadow-lg transition-shadow duration-300"
                                onClick={() => handleImageClick(image)} // Set the image on click
                            >
                                <img
                                    src={image}
                                    alt={`Gallery Image ${index + 1}`}
                                    className="w-full h-64 object-cover hover:scale-105 transition-transform duration-300 cursor-pointer"
                                />
                            </div>
                        ))}
                    </div>
                </div>

                {/* Modal to show selected image */}
                {selectedImage && (
                    <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50 " >
                        <div className="relative">
                            <img
                                src={selectedImage}
                                alt="Selected"
                                className="max-w-full max-h-screen rounded-lg"
                            />
                            <button
                                onClick={handleClose}
                                className="absolute top-2 right-2 text-white bg-red-600 hover:bg-red-700 rounded-full p-2"
                            >
                                ✖
                            </button>
                        </div>
                    </div>
                )}
            </section>

            {/* <Footer /> */}
        </div>
    );
};

export default Gallery;
